import { SET_GIFT_CARD_TO_REMOVE } from 'redux/modules/order/actions/types';

const setGiftCardToRemove = giftCard => dispatch =>
  dispatch({
    type: SET_GIFT_CARD_TO_REMOVE,
    giftCard,
  });
export default setGiftCardToRemove;
